import React from "react";
import { Loader as Load } from "react-loaders";

export const Loader = (
  <Load type="ball-pulse" className="animated fadeIn pt-3 text-center" />
);
